import { AppState } from 'store/store';

export const applicantSelector = (state: AppState) => state.applicants.details;
